
module.exports ={
    queryApply:'/queryApply',
    dateinfo: '/CifitSystem/api/home/cifitHome/dateinfo.jhtml'
}


// WEBPACK FOOTER //
// ./src/util/api.js